import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token'); // Check if user is logged in

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <header className="bg-blue-600 text-white p-4 shadow-md">
            <div className="container mx-auto flex justify-between items-center">
                <Link to="/" className="text-2xl font-bold">Booking App</Link>
                <nav>
                    {token ? (
                        <>
                            <Link to="/dashboard" className="mx-2 hover:underline">My Bookings</Link>
                            <Link to="/book" className="mx-2 hover:underline">Book Now</Link>
                            <Link to="/admin" className="mx-2 hover:underline">Admin</Link>
                            <button onClick={handleLogout} className="mx-2 hover:underline bg-red-500 px-3 py-1 rounded">Logout</button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="mx-2 hover:underline">Login</Link>
                            <Link to="/register" className="mx-2 hover:underline">Register</Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
};

export default Header;